module.exports = __webpack_public_path__ + "img/icon-marked-review.28867983.svg";